import React, { HTMLAttributes } from 'react'
import Box, { TBox } from '@components/Box'
import { general } from '@styles/theme'

export interface IContainer extends TBox, HTMLAttributes<HTMLDivElement> {}

const Container: React.FC<IContainer> = ({ children, ...rest }) => {
  const { containerWidth, containerPaddingX, containerPaddingXMd, containerPaddingXSm } = general
  return (
    <Box
      maxWidth={`${containerWidth}px`}
      paddingX={{ _: `${containerPaddingXSm}px`, md: `${containerPaddingXMd}px`, xl: `${containerPaddingX}px` }}
      marginX="auto"
      {...rest}
    >
      {children}
    </Box>
  )
}

export default Container
